import { apiClient } from './client'

export type StandaloneSetupProviderId =
  | 'openai'
  | 'anthropic'
  | 'google'
  | 'mistral'
  | 'openrouter'
  | 'ollama'
  | 'local'
  | 'custom'

export interface StandaloneSetupProvider {
  id: string
  name: string
  provider: string
  url?: string
  model?: string
  systemPrompt?: string
  maxCompletionTokens?: number
}

export interface StandaloneSetupStatus {
  configured: boolean
  provider?: StandaloneSetupProvider
  deploymentId?: string
  deploymentName?: string
  organizationId?: string
  organizationName?: string
  hostedConfigured?: boolean
  hostedMode?: string
  consoleBound?: boolean
  consoleInstanceId?: string
}

export interface StandaloneSetupStatusParams {
  organizationId?: string
  deploymentId?: string
}

export interface StandaloneSetupRequest {
  provider: StandaloneSetupProviderId
  name?: string
  model?: string
  apiKey?: string
  url?: string
  systemPrompt?: string
  maxCompletionTokens?: number
  organizationId?: string
  deploymentId?: string
}

export interface StandaloneSetupError {
  code: string
  message: string
  field?: string
  hint?: string
}

export interface StandaloneSetupTestResponse {
  ok: boolean
  latencyMs?: number
  provider?: string
  model?: string
  message?: string
  error?: StandaloneSetupError
}

export interface StandaloneSetupSaveResponse {
  ok: boolean
  providerId?: string
  configured: boolean
  warnings?: string[]
  spaceId?: string
  sessionId?: string
  calistoDeploymentId?: string
  calistoSpaceId?: string
  calistoSessionId?: string
}

export const standaloneSetupAPI = {
  getStatus: (params?: StandaloneSetupStatusParams) => {
    const query: Record<string, string> = {}
    if (params?.organizationId) {
      query.organizationId = params.organizationId
    }
    if (params?.deploymentId) {
      query.deploymentId = params.deploymentId
    }
    return apiClient.get<StandaloneSetupStatus>(
      '/standalone/setup/status',
      Object.keys(query).length > 0 ? { params: query } : undefined,
    )
  },
  testConfig: (payload: StandaloneSetupRequest) =>
    apiClient.post<StandaloneSetupTestResponse>('/standalone/setup/test', payload),
  saveConfig: (payload: StandaloneSetupRequest) =>
    apiClient.post<StandaloneSetupSaveResponse>('/standalone/setup/save', payload),
}
